<div class="container-fluid wrapper-page">
    <div class="page-head">
        <h5 class="header-title heading-color">Medical Records</h5>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="card m-b-30">
                <div class="card-body">

                    <!-- DISPLAY PATIEN DETAILS Starts-->

                    <div class="container-fluid">
                        <div class="bg-primary text-white p-1">
                            <h5 class="mt-2 ml-4">PATIENT PROFILE</h5>
                        </div>
                        <div class="card m-b-30">
                            <div class="card-body">
                                <div class="col-md-12 d-flex">

                                    <div class="col-md-4">

                                        <div *ngIf="patient.avatarimg !='img_avatar.png'" style="text-align: center; ">
                                            <img [src]="patient.ppurl" class="image">
                                        </div>
                                        <div class="profileImage" *ngIf="patient.avatarimg =='img_avatar.png'"
                                            style="text-align: center;">
                                            <avatar text={{patient?.name}} hash={{patient?.name}}>
                                            </avatar>
                                        </div>


                                        <!-- <img [src]="patient && patient.ppurl ? patient.ppurl : ''" class="image"> -->
                                    </div>
                                    <div class="col-md-8">
                                        <div class="row marBt5">
                                            <div class="col-5">
                                                <label class="label1">Name:</label>
                                            </div>
                                            <div class="col-7">
                                                <label *ngIf="patient && patient.first_name"
                                                    class="label2">{{patient.first_name}}
                                                    {{patient.last_name}}</label>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-5">
                                                <label class="label1">Email:</label>
                                            </div>
                                            <div *ngIf="patient && patient.email_id" class="col-7 customa">
                                                <label class="label2">{{patient.email_id}}</label>
                                            </div>
                                        </div>
                                        <div class="row marBt5">
                                            <div class="col-5">
                                                <label class="label1">Gender:</label>
                                            </div>
                                            <div class="col-7">
                                                <label *ngIf="patient && patient.gender"
                                                    class="label2">{{patient.gender}}</label>
                                            </div>
                                        </div>
                                        <div class="row marBt5">
                                            <div class="col-5">
                                                <label class="label1">Date of Birth:</label>
                                            </div>
                                            <div class="col-7">
                                                <label *ngIf="patient && patient.dob" class="label2">{{patient.dob |
                                                    date:'dd-MM-yyyy'}}</label>
                                            </div>
                                        </div>
                                        <div class="row marBt5">
                                            <div class="col-5">
                                                <label class="label1">Address:</label>
                                            </div>
                                            <div class="col-7">
                                                <label *ngIf="patient && patient.city_n"
                                                    class="label2">{{patient.address_1}}{{patient.address_2}}{{patient.city_n}}</label>
                                            </div>
                                        </div>
                                        <div class="row marBt5">
                                            <div class="col-5">
                                                <label class="label1">Contact No:</label>
                                            </div>
                                            <div class="col-7">
                                                <label *ngIf="patient && patient.contact_no"
                                                    class="label2">{{patient.contact_no}}</label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- DISPLAY PATIEN DETAILS ENDS-->



                    <!-- PATIENT STATISTICS STARTS -->
                    <div class="container-fluid ">
                        <div class="bg-primary text-white p-1">
                            <h5 class="mt-2 ml-4">PATIENT HEALTH STATISTICS</h5>
                        </div>
                        <div class="card m-b-30">
                            <div class="card-body">
                                <section class="mt-35 ml-2 align-items-center">
                                    <form [formGroup]="forms['patstats']">

                                        <ul class="ul1">
                                            <li class="li1" formArrayName="pat_stats"
                                                *ngFor="let item of forms['patstats']?.get('pat_stats')['controls']; let i = index;">
                                                <div class="row" [formGroupName]="i">
                                                    <div class="col-md-12 d-flex">
                                                        <div class="col-sm-6 col-md-4 mt-3 mb-2">
                                                            <label>{{getStatsLabel(i)}}</label>
                                                        </div>

                                                        <div class="col-sm-6 col-md-3  mb-2 ">
                                                            <input formControlName="stats_value" placeholder=""
                                                                name="stats_value" type="text" class="form-control">
                                                            <div *ngIf="getStatsLabel(i) === getStatsLabel(2) ">
                                                                <label class="font-italic text-danger">eg:Systolic /
                                                                    Diastolic</label>
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-6 mt-3 col-md-3 "><span class=" mt-3"
                                                                style="font-size: 12px;">{{getStatsuom(i)}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6 col-md-2 mt-3"></div>
                                                </div>
                                            </li>
                                            <li class="li1"
                                                *ngIf="forms['patstats']?.get('pat_stats')['controls']?.length % 2 != 0">
                                            </li>
                                        </ul>

                                    </form>
                                </section>
                            </div>
                        </div>

                    </div>
                    <!-- PATIENT STATISTICS ENDS -->






                    <!--  PRESCRIBED LAB REQUEST STARTS -->
                    <div class="container-fluid ">
                        <!-- <div class="bottomForm">
                  <div class="row"> -->
                        <div class="bg-primary text-white p-1">
                            <h5 class="mt-2 ml-4">PRESCRIBED LAB REQUESTS</h5>
                        </div>
                        <div class="card-body-1 table-responsive">

                            <div class="card m-b-30">
                                <div class="card-body">
                                    <div class="col-sm-12 table-responsiv">
                                        <table id="datatable2" class="table dataTable no-footer" role="grid"
                                            aria-describedby="datatable2_info">
                                            <thead>
                                                <tr role="row">
                                                    <th class="sorting_asc" tabindex="0" aria-controls="datatable2"
                                                        rowspan="1" colspan="1" aria-sort="ascending"
                                                        aria-label="Name: activate to sort column descending"
                                                        style="width: 16%">
                                                        Date
                                                    </th>
                                                    <th class="sorting" tabindex="0" aria-controls="datatable2"
                                                        rowspan="1" colspan="1"
                                                        aria-label="Position: activate to sort column ascending"
                                                        style="width: 16%">
                                                        Name of test
                                                    </th>
                                                    <th class="sorting" tabindex="0" aria-controls="datatable2"
                                                        rowspan="1" colspan="1"
                                                        aria-label="Office: activate to sort column ascending"
                                                        style="width: 20%">
                                                        Remarks
                                                    </th>
                                                    <th class="sorting" tabindex="0" aria-controls="datatable2"
                                                        rowspan="1" colspan="1"
                                                        aria-label="Age: activate to sort column ascending"
                                                        style="width: 16%">
                                                        Status
                                                    </th>
                                                    <th class="sorting" tabindex="0" aria-controls="datatable2"
                                                        rowspan="1" colspan="1"
                                                        aria-label="Age: activate to sort column ascending"
                                                        style="width: 22%">
                                                        Attachment
                                                    </th>
                                                    <th class="sorting" tabindex="0" aria-controls="datatable2"
                                                        rowspan="1" colspan="1"
                                                        aria-label="Age: activate to sort column ascending"
                                                        style="width: 10%">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody *ngFor="let record of testsList">
                                                <tr role="row" class="odd" *ngIf="record.tstat !== 'Reviewed' ">
                                                    <td>
                                                        {{ record.tdate | date: "dd-MM-yyyy" }}
                                                    </td>
                                                    <td>
                                                        {{ record.labtest_name }}
                                                        <input type="hidden" name="testid" value="record.testid" />
                                                    </td>
                                                    <td>{{ record.remarks }}</td>
                                                    <td>{{ record.tstat }}</td>
                                                    <td>
                                                        <div class="gridimg" *ngFor="
                              let report of record.attachments;let i=index;
                            ">
                                                            <div
                                                                *ngIf="record.attachments.ext[i]!='' && record.attachments.ext[i]=='pdf'">
                                                                <!-- <a [href]="report" target="_blank"> -->
                                                                <a class="cursor" (click)="previewDocuments(report)">
                                                                    <span class="fa-stack fa-lg">
                                                                        <i class="fa fa-circle fa-stack-2x"></i>
                                                                        <i
                                                                            class="fa fa-file-pdf-o fa-stack-1x fa-inverse"></i>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div
                                                                *ngIf="record.attachments.ext[i]!='' &&  record.attachments.ext[i]!='pdf'">
                                                                <a class="cursor" (click)="previewDocuments(report)">
                                                                    <img [src]="report"
                                                                        style="width: 30px;height:30px; border-radius:50%;max-width:100%;cursor:pointer"
                                                                        class=" modal-hover-opacity" data-toggle="modal"
                                                                        data-target="#myModal" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>

                                                        <a (click)="openEditLabTest(labTestModal,record)">
                                                            <i class="fa fa-paperclip" style="font-size:24px"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                            <!-- </div>
                  </div> -->
                        </div>
                    </div>
                    <!--  PRESCRIBED LAB REQUEST ENDS -->

                    <div class="container ">

                        <button type="button" class=" btn btn-primary button1" (click)="statuscheck()">Update
                            Medical Records</button>

                        <button type="button" class=" btn btn-info button1  " (click)="goBack()">Back</button>

                        <!-- <button type="button" class=" btn btn-primary button1 " routerLink="/appointments/Checkout"
                  *ngIf="!disableSubmit" (click)="saveDocuments();savestats();statuscheck()">Check-In</button> -->
                        <!-- <button type="button" class="btn btn-primary button1" (click)="savestats()">Check-In</button> -->
                    </div>


                </div>

            </div>
            <!-- Modal for preview docs -->




            <!--new changes -->
            <ng-template #PDFModal>
                <div>
                    <div class="modal-header">
                        <button type="button" class="close" (click)=closeModal()>&times;</button>
                    </div>
                    <div>
                        <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
                    </div>
                </div>
            </ng-template>




            <!-- ============== MODAL ================== -->
            <ng-template #labTestModal let-modal>
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        {{selectedLabTest.labtest_name}}
                        <span>Test Date: {{selectedLabTest.tdate| date:'dd-MM-yyyy'}}</span>
                    </h5>
                    <!-- <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button> -->
                </div>


                <form [formGroup]="modalForm">
                    <div class="modal-body">
                        <div class="gridimg_modal" formArrayName="report_attachments"
                            *ngFor="let record of modalForm.get('report_attachments')['controls']; let i=index;">

                            <div [formGroupName]="i">
                                <!-- {{report_attachments.controls[i].get('s3Key').value.split('?')[0].split('.').pop()}} -->

                                <div
                                    *ngIf="report_attachments.controls[i].get('s3Key').value.split('?')[0].split('.').pop()=='pdf'">
                                    <a [href]="report" target="_blank">
                                        <span class="fa-stack fa-lg">
                                            <i class="fa fa-circle fa-stack-2x"></i>
                                            <i class="fa fa-file-pdf-o fa-stack-1x fa-inverse"></i>
                                        </span>
                                    </a>
                                    <!-- <i (click)="deleteAttachment(i)" class="fa fa-trash trash-icon"></i> -->
                                </div>

                                <div
                                    *ngIf="report_attachments.controls[i].get('s3Key').value.split('?')[0].split('.').pop()!='pdf'">
                                    <img [src]="report_attachments.controls[i].get('s3Key').value"
                                        style="width: 50px;height:50px; border-radius:50%;max-width:100%;cursor:pointer" />
                                    <!-- <i (click)="deleteAttachment(i)" class="fa fa-trash trash-icon"></i> -->
                                </div>


                            </div>


                        </div>
                        <br /><br />
                        <label for="reportsRef">
                            <input class="form-control text-dark" type="file" id="reportsRef"
                                accept="application/pdf, image/*" #reportsRefImage
                                (change)="uploadReports($event.target.files)" multiple>
                        </label>



                    </div>
                </form>


                <div class=" modal-footer">
                    <button type="button" class="btn btn-secondary"
                        (click)="modal.dismiss('Cross click')">Cancel</button>
                    <button type="button" class="btn btn-primary" [disabled]="files.length > 0"
                        (click)="updateLabTest(modalForm.value);modal.dismiss('Cross click')">Update
                        Report</button>
                </div>
            </ng-template>
            <!-- ======================================= -->